import { Typography } from 'antd';
import { useIntl } from 'umi';
import { ServiceRequestModel } from '@/typings/models/ServiceRequest';
import styles from './index.less';

export default function ServiceRequestMigrationInfo({serviceRequest}: { serviceRequest: ServiceRequestModel }) {
  const intl = useIntl();
  const source = serviceRequest?.migration_source;
  const id = serviceRequest?.migration_id;

  if (!source || !id) {
    return null;
  }

  const label = `${source}-ID`;

  return (
    <Typography.Text
      className={styles.migrationInfo}
      copyable={{
        text: id,
        icon: [label, label],
        tooltips: [
          <span key="id" className={styles.migrationInfoTooltip}>{id}</span>,
          intl.formatMessage({ id: 'common.actions.copied', defaultMessage: 'Copied' }),
        ],
      }}
    />
  );
}
